const ENVIRONMENTS = Object.freeze({
  test: Object.freeze({
    apiUrls: Object.freeze({
      cdn: 'https://mvusr.foxie.cc',
      direct: 'https://mvusr-direct.foxie.cc',
    }),
    aesKey: '2LXNLewllFXw4qDC',
    supportsSectionRange: true,
  }),
  prod: Object.freeze({
    apiUrls: Object.freeze({
      cdn: 'https://cvo.kuaicloud.one',
      direct: 'https://cvo.kuaicloud.one',
    }),
    aesKey: 'kWJ2D5aDlneVeRcr',
    supportsSectionRange: false,
  }),
});

const searchParams = new URLSearchParams(window.location.search);
const requestedEnvironment = searchParams.get('env')?.toLowerCase();
const networkPath = searchParams.get('path')?.toLowerCase() === 'direct' ? 'direct' : 'cdn';
const debugEnabled = ['1', 'true'].includes(searchParams.get('debug')?.toLowerCase());
const localEnvironment = ['localhost', '127.0.0.1'].includes(window.location.hostname)
  ? 'test'
  : 'prod';
const environment = Object.hasOwn(ENVIRONMENTS, requestedEnvironment)
  ? requestedEnvironment
  : localEnvironment;
const environmentConfig = ENVIRONMENTS[environment];

export const APP_CONFIG = Object.freeze({
  environment,
  networkPath,
  debugEnabled,
  apiUrl: environmentConfig.apiUrls[networkPath],
  aesKey: environmentConfig.aesKey,
  supportsSectionRange: environmentConfig.supportsSectionRange,
  appVersion: '1.0.0',
  requestTimeoutMs: 30_000,
  homeTypeId: 1001,
  homePageSize: 36,
  initialSectionCount: 2,
});

export function appHref(path) {
  const params = new URLSearchParams(window.location.search);
  params.set('env', APP_CONFIG.environment);
  return `${path}?${params.toString()}`;
}
